import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useCombats from '@api/hooks/goal/test-series/useCombats';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';

const useCombatFetch = ({ selectedFirstLevel, selectedSeceondLevel }) => {
  const { query } = useRouter();
  const { goalUID } = query;

  const isLoggedIn = useMyInfo(getIsLoggedIn);

  const {
    combatsData,
    size,
    setSize,
    isLoading,
    isValidating,
    mutate: refetchCombats
  } = useCombats(goalUID, selectedSeceondLevel.value, selectedFirstLevel.value);

  const loadMore = () => setSize(size + 1);

  useEffect(() => {
    if (isLoggedIn) refetchCombats();
  }, [isLoggedIn, refetchCombats]);

  return {
    combatsData,
    isLoading,
    isValidating,
    loadMore
  };
};

export default useCombatFetch;
